import { parseDataAttributes } from '../../utilities/utilities'

export interface CartQuantityConfigStyles {
  badgeBackgroundColor?: { color?: string }
  badgeTextColor?: { color?: string }
}

export interface CartQuantityAttributes {
  configStyles?: CartQuantityConfigStyles
}

export function getCartQuantityAttributes(attrs: NamedNodeMap): CartQuantityAttributes {
  const base = parseDataAttributes(attrs) as Record<string, unknown>

  return {
    configStyles: base.configStyles as CartQuantityConfigStyles | undefined,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): CartQuantityAttributes {
  return getCartQuantityAttributes(dataAttributes)
}
